<eo-base-form-control
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-autoComplete
    [id]="id"
    [tabindex]="getTabIndex()"
    [appendTo]="getAppendTo()"
    attr.aria-describedby="{{ id }}-help"
    styleClass="w-full {{ getInputStyleClass() }}"
    inputStyleClass="w-full {{ getInputStyleClass() }}"
    (loadingPlaceholder)="getLoadingPlaceholder()"
    [formControl]="getFormControl()"
    [suggestions]="getSuggestions()"
    [showClear]="getShowClear()"
    (completeMethod)="filterSuggestions($event)"
    [optionLabel]="getOptionLabel()"
    [field]="getOptionValue()"
    [showEmptyMessage]="getShowEmptyMessage()"
    [emptyMessage]="getEmptyMessage()"
    [placeholder]="getPlaceholder()"
    [multiple]="getMultiple()"
    (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    (onSelect)="select.emit($event)"
  >
    <ng-content />
  </p-autoComplete>
</eo-base-form-control>
